import {
  RECEIVED_PRINTED_MODELS_INFO_OVERRIDE, ERROR_ON_GETTING_PRINTED_MODELS, START_FETCHING_PRINTED_MODELS,
  UPDATE_TOGGLE_LIST_OF_PRINT_ITEMS, RECEIVED_PRINTED_MODELS_INFO_APPEND, TOGGLE_PRINT_FILTER, CHANGE_DATE_FILTER_START,
  CHANGE_DATE_FILTER_END, CHANGE_MODEL_NAME_FILTER, SEARCH_PRINT_RECORDS_BY_EMAIL, CHANGE_SEARCH_EMAIL,
  CLEAR_PRINTED_MODELS_INFO, INIT_LOADING_AND_HASMORE_STATUS, ERROR_ON_GETTING_PRINT_RECORD, CLEAR_ERROR,
  START_SEARCHING_PRINT_RECORDS 
} from "../actions/types";
import moment from "moment";

const initialState = {
  printedModels: [],
  togglesOfPrintRecordItems: [],
  loading: true,
  // for infinite scrolling
  timeStampOfBottomRecord: Date.now(),
  hasMore: true,
  // filter states
  filtersOn: true,
  startTimeStamp: 0,
  // initial endTimeStamp set to 24 hours later, to show all prints later added
  endTimeStamp: moment(new Date()).add(1,'days').toDate().getTime(),
  modelNameFilter: '',
  email: '',
  error: '',
}

const printedModelsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  let hasMore = state.hasMore;
  let timeStampOfBottomRecord = state.timeStampOfBottomRecord;
  switch (type) {
    case START_FETCHING_PRINTED_MODELS:
      return { ...state, loading: true }
    case RECEIVED_PRINTED_MODELS_INFO_APPEND:
      const prevPrintedModelList = state.printedModels;
      const newPrintedModelList = [ ...prevPrintedModelList, ...payload.printedModels ]
      hasMore = payload.printedModels.length !== 0;
      timeStampOfBottomRecord = newPrintedModelList[newPrintedModelList.length - 1].timeStamp;
      return { ...state, loading: false, printedModels: newPrintedModelList, hasMore, timeStampOfBottomRecord }
    case RECEIVED_PRINTED_MODELS_INFO_OVERRIDE:
      hasMore = payload.printedModels.length !== 0;
      timeStampOfBottomRecord = hasMore ? payload.printedModels[payload.printedModels.length - 1].timeStamp : Date.now();
      return { ...state, loading: false, ...payload, hasMore, timeStampOfBottomRecord }
    case ERROR_ON_GETTING_PRINTED_MODELS:
      return { ...state, loading: false, ...payload, hasMore: false }
    case UPDATE_TOGGLE_LIST_OF_PRINT_ITEMS:
      return { ...state, ...payload }
    case TOGGLE_PRINT_FILTER:
      return { ...state, filtersOn: !state.filtersOn }
    case CHANGE_DATE_FILTER_START:
      const startOfDay = Number(payload.date.format('x'));
      return { ...state, startTimeStamp: startOfDay }
    case CHANGE_DATE_FILTER_END:
      const endOfDay = Number(payload.date.format('x')) + 1000 * 60 * 60 * 24;
      return { ...state, endTimeStamp: endOfDay}
    case CHANGE_MODEL_NAME_FILTER:
      return { ...state, modelNameFilter: payload.modelName }
    case CHANGE_SEARCH_EMAIL:
      return { ...state, email:payload.email}
    case SEARCH_PRINT_RECORDS_BY_EMAIL:
      return { ...state, loading:true, hasMore:true}
    case CLEAR_PRINTED_MODELS_INFO:
      return { ...state, printedModels:[], loading: false, hasMore: false, email: '',  togglesOfPrintRecordItems: [], error: '',}
    case INIT_LOADING_AND_HASMORE_STATUS:
      return { ...state, loading: false, hasMore:false}
    case ERROR_ON_GETTING_PRINT_RECORD:
      return { ...state, error: payload.error}
    case CLEAR_ERROR:
      return { ...state, error: ''}
    case START_SEARCHING_PRINT_RECORDS:
      return { ...state, printedModels:[], togglesOfPrintRecordItems: [], error: '',}
    default:
      return state;
  }
}

export default printedModelsReducer;


// WEBPACK FOOTER //
// ./src/reducers/printed-models-reducer.js